import { Button, MantineBreakpoint } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";

export function BackButton({
  label,
  to,
  visibleFrom,
  w,
}: {
  label: string;
  to?: string;
  visibleFrom?: MantineBreakpoint;
  w?: React.CSSProperties["width"];
}) {
  const navigate = useNavigate();

  return (
    <Button
      visibleFrom={visibleFrom}
      variant="subtle"
      color="dimmed"
      size="xs"
      component={Link}
      to={to || ""}
      w={w}
      onClick={
        to
          ? undefined
          : () => {
              /** If no `to` is provided, we simply go back in history: */
              navigate(-1);
            }
      }
      leftSection={<IconChevronLeft size={14} />}
    >
      {label}
    </Button>
  );
}
